import React from 'react';
import { motion } from 'framer-motion';
import truckImage from '../../assets/cvj-heavy-truck.jpg';
import convoyImage from '../../assets/cvj-freight-convoy.jpeg';
import loadingImage from '../../assets/cvj-low-loader.jpg';
import cargoImage from '../../assets/cvj-lorry.jpg';
import './HeroSection.css';

const HeroSection = () => {
  // Image animation
  const imageVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay: i * 0.3, ease: 'easeOut' },
    }),
  };

  // Content animation
  const contentVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, delay: 1.2 } 
    },
  };

  return (
    <section className="hero-section">
      {/* Image Containers */}
      <motion.div
        className="image-container truck-image"
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        custom={0}
        whileHover={{ scale: 1.03 }}
      >
        <img src={truckImage} alt="Heavy Truck" className="hero-image" />
      </motion.div>

      <motion.div
        className="image-container convoy-image"
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        custom={1}
        whileHover={{ scale: 1.03 }}
      >
        <img src={convoyImage} alt="Freight Convoy" className="hero-image" />
      </motion.div>

      {/* <motion.div
        className="image-container loading-image"
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        custom={2}
        whileHover={{ scale: 1.03 }}
      >
        <img src={loadingImage} alt="Low Loader" className="hero-image" />
      </motion.div> */}

      <motion.div
        className="image-container cargo-image"
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        custom={3}
        whileHover={{ scale: 1.03 }}
      >
        <img src={cargoImage} alt="Cargo Lorry" className="hero-image" />
      </motion.div>

      {/* Content */}
      <motion.div
        className="hero-content"
        variants={contentVariants}
        initial="hidden"
        animate="visible"
      >
        <h1 className="hero-title">CVJ Services Ltd</h1>
        <a href="#contact" className="hero-cta">
          Start Shipping
        </a>
      </motion.div>
    </section>
  );
};

export default HeroSection;